/*
 * @Date: 2019-08-20 18:41:00
 * @LastEditors: x
 * @LastEditTime: 2019-09-06 12:13:37
 */
export const SET_IS_DIALOG_FROM_LOGIN = 'SET_IS_DIALOG_FROM_LOGIN'
export const SET_Register_Params = 'SET_Register_Params'


// WEBPACK FOOTER //
// ./src/store/mutation-types.js